import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import VacanciesList from '../../components/VacanciesList';
import CitySelect from '../../components/CitySelect';
import WorkersList from '../../components/WorkersList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadInternshipList } from '../../actions/InternshipListActions';

class PageInternships extends Component {
  static requestData(store) {
    return requestAll([loadInternshipList], store);
  }

  componentDidMount() {
    this.props.actions.loadInternshipList();
  }
  render() {
    return (
      <div>
        <div className="container container--indentVertical">
          <Helmet>
              <title>Стажировки для студентов в ЭР-Телеком Холдинг – Начни карьеру уже сегодня</title>
              <meta name="description" content="Узнай о возможностях стажировок для студентов в ЭР-Телеком Холдинг. Реальные проекты, опытные наставники и шанс начать успешную карьеру в ведущей телекоммуникационной компании." />
          </Helmet>
          <CitySelect main="в Екатеринбурге">Стажировка</CitySelect>
          <div className="text text--top30">У&nbsp;нас всегда открыт набор молодых людей на&nbsp;различные программы обучения в&nbsp;компании. В&nbsp;течение года мы&nbsp;предлагаем студентам пройти практику по&nbsp;специальности. Молодые программисты из&nbsp;Перми под руководством наших специалистов могут пройти стажировку по&nbsp;программе ORACLE, а&nbsp;студентов Иннополиса мы&nbsp;приглашаем пройти оплачиваемую стажировку в&nbsp;штаб-квартире.</div>
        </div>
        <h1 className="text--hide">Стажировка в ЭР-Телеком</h1>
        <div className="container container--indentVertical">
          <VacanciesList cols={6} vacancies={this.props.internshipList} isInternship={this.props.isInternship}/>
        </div>
        <div className="container container--indentVertical">
          <h2 className="text text--h2">У нас уже работают</h2>
          <div className="text text--bottom40">Ежегодно в&nbsp;компании проходят различные стажировки более 150&nbsp;человек, больше половины остались работать вместе с&nbsp;нами.</div>
          <WorkersList cols={4}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      internshipList: state.internshipList,
      isInternship: true
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInternshipList }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageInternships));



// WEBPACK FOOTER //
// ./src/pages/PageInternships/index.js